import React from 'react';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const ExtensionMessage = ({ hasZiggeoForAllMedia, recordingNotSupported }) => (
  <div>
    {!hasZiggeoForAllMedia && !recordingNotSupported && (
      <div className="Response-notice mb-16">
        <div>
          <Text variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD}>
            {t(
              'questions.question.hippo_screen_recording.instructions.download.condition',
            )}
          </Text>
          <Text variant={TEXT_VARIANTS.BODY_LIGHT}>
            {t(
              'questions.question.hippo_screen_recording.instructions.download.content',
            )}
          </Text>
        </div>
      </div>
    )}
  </div>
);

export default ExtensionMessage;
